import { PAGINATION_MAPPINGS } from '../constants/table.constants';
import { typeToString } from '../lib/dossier.utils';
import { DOSSIERS_RESOURCE } from './dossiers.resource';

export const DOSSIERS_RELATED_RESOURCE = {
  key: 'DOSSIERS_RELATED_RESOURCE',
  table: {
    defaultSort: '-dossierNumber',
    dataLocation: '_embedded.static',
    disablePagination: true,
    enableSelect: true,
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i,
        fileType: typeToString(i.fileType),
        fileThemes: i?.fileThemes?.map((t) => t?.name)?.join(', ') ?? ''
      })),
    pageMapping: PAGINATION_MAPPINGS.DOSSIERS,
    fields: [
      {
        value: 'dossierNumber',
        label: 'Dossiernr',
        show: true,
        order: 0
      },
      { value: 'fileType', label: 'Type', show: true, order: 1 },
      { value: 'fileThemes', label: 'Label', show: true, blockSort: true, order: 2 },
      { value: 'reason', label: 'Reden', show: true, order: 3 }
    ]
  }
};

export const DOSSIERS_RELATED_SEARCH_RESOURCE = {
  ...DOSSIERS_RESOURCE,
  table: {
    ...DOSSIERS_RESOURCE.table,
    enableSelect: true
  },
  key: 'DOSSIERS_RELATED_SEARCH_RESOURCE',
  detailPath: null
};
